import React from 'react';
import styles from '../Rooms.module.css';

const DynamicIcon = ({
  icon,
  yearIcon,
  nameIcon,
  index,
  type,
  data,
  openDetail,
}) => {
  return (
    <>
      <div id={`icon${index}`} className={`on-screen-icon ${styles.icon}`}>
        <div
          onMouseDown={(e) => {
            if (e.button === 0) {
              openDetail(type, data);
            }
          }}
        >
          <div className={`${styles.out} ${styles.setPulse}`}>
            <img src={icon} className={styles.iconSvg} alt="" />
          </div>
        </div>
        <div className={styles.verticalLine}></div>
        <div className={styles.nameAndYear}>
          <div>{nameIcon}</div>
          <div>{yearIcon}</div>
        </div>
        <div className={styles.bottomCircle}></div>
      </div>
    </>
  );
};

export default DynamicIcon;
